import _ from 'lodash';
import type { Store } from 'redux';
import type { RootState } from 'src/store/app';
import { getSubdomain } from 'tldts';
import Analytics from './analytics/Analytics';
import { isLocalContainer } from './project.utils';

let store: Store<RootState>;

export const setStore = (newStore: Store<RootState>): void => {
    store = newStore;
};

let shouldTransformAnalyticEvents = false;
export const setShouldTransformAnalyticEvents = (newShouldTransformEvents: boolean): void => {
    shouldTransformAnalyticEvents = newShouldTransformEvents;
};

export const mergeEventDataWithGlobal = (state: RootState, additionalData?: Record<string, $TSFixMe>) => {
    const { user } = state.global;
    const { project, environment } = state.studio;

    const subdomain = getSubdomain(window.location.href);
    const isLocal = isLocalContainer(project);

    return _.omitBy(
        {
            createUserId: user ? user.id : null,
            projectId: project ? project.id : null,
            createOrganizationId: project ? project.organizationId : null,
            environment,
            subdomain,
            branch: process.env.BRANCH,
            isLocal: isLocal || null,
            ...additionalData
        },
        _.isNil
    );
};

const CREATE_EVENT_PREFIX = 'create:';
const STUDIO_EVENT_PREFIX = 'studio:';

const transformEventName = (eventName: string): string => {
    const prefix = window.location.pathname.startsWith('/studio') ? STUDIO_EVENT_PREFIX : CREATE_EVENT_PREFIX;
    if (!eventName.startsWith(prefix)) {
        eventName = prefix + eventName;
    }

    eventName = eventName.replace(/\s/g, '_');

    return eventName.toLowerCase();
};

export const dispatchAnalyticsEvent = (message: string, additionalData?: Record<string, $TSFixMe>): void => {
    if (process.env.STORYBOOK) {
        return;
    }

    const { urlParams } = store.getState().global;
    const eventData = mergeEventDataWithGlobal(store.getState(), additionalData);

    if (shouldTransformAnalyticEvents) {
        message = transformEventName(message);
    }

    if (urlParams.analyticsDebug) {
        // eslint-disable-next-line no-console
        console.log(message, eventData);
        return;
    }

    Analytics.track(message, eventData);
};

export const dispatchAnalyticsEventDebounced = _.debounce((message, additionalData) => {
    dispatchAnalyticsEvent(message, additionalData);
}, 1000);
